import useMountEffect from '@restart/hooks/useMountEffect';
import classNames from 'classnames/bind';
import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import styles from './ModifyUserInfo.module.scss';

import actions from '@/actions';
import { FieldText } from '@/components/ui/kit/Field';
import ModalWrapper from '@/components/ui/ModalWrapper';
import API from '@/helpers/API';
import { ModalService as modal } from '@/libs/Modal';
import { NotifierService as notifier } from '@/libs/Notifier';

const cx = classNames.bind(styles);

const Modal = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const [info, setInfo] = useState({
    name: user.name,
    cellphone: user.cellphone ?? '',
  });

  const nameRef = useRef();
  const cellphoneRef = useRef();

  useMountEffect(() => {
    // 이름 입력 필드 포커스
    nameRef.current.focus();
  });

  const close = () => {
    modal.hide();
  };

  const handleChange = (e) => {
    setInfo({
      ...info,
      [e.target.name]: e.target.value,
    });
  };

  const pressEnter = (e) => {
    if (e.nativeEvent.isComposing) return;

    if (e.code === 'Enter') {
      switch (e.target.name) {
        case 'name':
          cellphoneRef.current.focus();
          break;

        case 'cellphone':
          doModify();
          break;

        default:
          break;
      }
    }
  };

  // 유효성 검사
  const validAll = () => {
    if (info.name.trim() === '') {
      notifier.error('Please enter your name.');
      nameRef.current.focus();
      return false;
    }
    if (info.cellphone.trim() === '') {
      notifier.error('Please enter your cellphone.');
      cellphoneRef.current.focus();
      return false;
    }
    return true;
  };

  const doModify = () => {
    if (!validAll()) return;

    const data = {
      name: info.name,
      cellphone: info.cellphone,
    };
    if (data.cellphone === '') {
      data.cellphone = null;
    }

    API.patch('/accounts', data).then(({ success }) => {
      if (success) {
        dispatch(actions.user.modify(data));
        close();
      }
    });
  };

  return (
    <ModalWrapper className={cx('container')}>
      <div className={cx('fields')}>
        <label>
          Name
          <FieldText
            ref={nameRef}
            name="name"
            maxLength={24}
            autoComplete="off"
            value={info.name}
            onChange={handleChange}
            onKeyDown={pressEnter}
          />
        </label>
        <label>
          Cellphone
          <FieldText
            ref={cellphoneRef}
            name="cellphone"
            maxLength={24}
            autoComplete="off"
            value={info.cellphone}
            onChange={handleChange}
            onKeyDown={pressEnter}
          />
        </label>
      </div>
      <div className={cx('buttons')}>
        <button type="button" className={cx('button')} onClick={close}>
          Cancel
        </button>
        <button type="button" className={cx(['button', 'accent'])} onClick={doModify}>
          Modify
        </button>
      </div>
    </ModalWrapper>
  );
};

export default Modal;
